module.exports = __webpack_public_path__ + "images/emoji/alarm_clock.2844dfc86f45e5ccdd44.png";